var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showClientHeader)?_c('header-client',{attrs:{"compID":_vm.compID,"className":_vm.className,"activeKey":_vm.activeKey},on:{"returnCompInfo":_vm.returnCompInfo}}):_c('header-web',{attrs:{"compID":_vm.compID,"className":_vm.className,"activeKey":_vm.activeKey},on:{"returnCompInfo":_vm.returnCompInfo}})
}
var staticRenderFns = []

export { render, staticRenderFns }